import React from 'react';
import styled from '@emotion/styled';
import Responsive from '../../../../../ui/utils/Responsive';
import { ITokenizedCard } from '../../../domain/models';
import { TokenizedCardTitle } from './TokenizedCardTitle';
import { FormattedExpiryDate } from './FormattedExpiryDate';

interface ITokenizedCardDetailsProps {
	card: ITokenizedCard;
}

export const TokenizedCardDetails = ({ card }: ITokenizedCardDetailsProps) => {
	const { expiryDate } = card;

	return (
		<StyledDetails>
			<TokenizedCardTitle card={card} />
			<FormattedExpiryDate expiryDate={expiryDate} />
		</StyledDetails>
	);
};

const StyledDetails = styled.div`
	flex-grow: 1;
	margin-left: 24px;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		margin-left: 16px;
	}
`;
